import { Controller } from "@hotwired/stimulus";
import hljs from "hb/hljs";

export default class extends Controller {
  connect() {
    const codeEl = this.element.querySelector("code");
    if (codeEl && !codeEl.dataset.highlighted) {
      hljs.highlightElement(codeEl);
    }
  }
}
